/**
 * 支付宝签约相关类型定义
 */

/** 签约状态枚举 */
export enum AlipaySignStateEnum {
  /** 待签约 */
  NOT_SIGNED = 'NOT_SIGNED',
  /** 签约中 */
  SIGNING = 'SIGNING',
  /** 已签约 */
  SIGNED = 'SIGNED',
}

/** 签约场景枚举 */
export enum AlipaySignSceneEnum {
  /** 还款-在新项目中 */
  REPAYMENT = 'REPAYMENT',
  /** 银行卡 */
  BANK_CARD = 'BANK_CARD',
}
/** 签约状态查询 - 请求参数 */
export interface AlipaySignQueryParams {
  /** 场景 */
  scene: AlipaySignSceneEnum;
}

/** 签约状态查询 - 响应 */
export interface AlipaySignInfoType {
  /** 是否展示签约组件 */
  show: boolean;
  /** 签约状态 */
  signState: AlipaySignStateEnum;
}

/** 申请签约 - 响应 */
export interface AlipaySignApplyResponse {
  /** 支付宝签约地址 */
  payUrl: string;
}

/** 查询支持的资方列表 - 响应 */
export interface AlipayCapitalListResponse {
  /** 支持的资方id列表 */
  capitalList: string[];
}
